import { HttpStatusCode } from '@angular/common/http';
import { formatDeleteHeaders, formatGetHeaders, formatPostHeaders } from '@configurations/api-configuration';
import { AnalystGateway } from '@scenario/gateways/analyst.gateway';
import { AnalystAssignment } from '@scenario/models/analyst-assignment.model';
import { environment } from '../../../../../environments/environment';
export class ApiAnalystGateway implements AnalystGateway {
  private readonly analystApi = `${environment.backend_url}/api/v1/analyst`;
  async retrieveAll(): Promise<AnalystAssignment[]> {
    const response = await fetch(this.analystApi, await formatGetHeaders());
    if (!response.ok) {
      throw new Error(`Failed to retrieve analysts: ${response.status}`);
    }
    return response.json();
  }
  async create(
    userId: number,
    sourceId: number,
    firstName?: string,
    lastName?: string,
    zoneIds?: number[],
  ): Promise<AnalystAssignment> {
    const response = await fetch(
      this.analystApi,
      await formatPostHeaders({ userId, sourceId, firstName, lastName, zoneIds }),
    );
    if (response.status !== HttpStatusCode.Created) {
      throw new Error(`Failed to create analyst: ${response.status}`);
    }
    return response.json();
  }
  async remove(id: number): Promise<AnalystAssignment> {
    const response = await fetch(`${this.analystApi}/${id}`, await formatDeleteHeaders());
    if (!response.ok) {
      throw new Error(`Failed to remove analyst: ${response.status}`);
    }
    return response.json();
  }
}
